import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, FileText, BarChart2, Users, Clipboard, Folder, CheckSquare, Award, Target, Newspaper, Star, Grid3x3, CalendarDays } from 'lucide-react';
import { UserContext } from '../../context/UserContext';
export function Sidebar() {
  const location = useLocation();
  const {
    userRole
  } = useContext(UserContext);
  const isActive = (path: string) => location.pathname === path;
  const employeeLinks = [{
    name: 'Tableau de bord',
    icon: Home,
    path: '/'
  }, {
    name: '2x4',
    icon: Newspaper,
    path: '/2x4'
  }, {
    name: 'Calendrier',
    icon: CalendarDays,
    path: '/calendrier'
  }, {
    name: 'Congés',
    icon: Calendar,
    path: '/conges'
  }, {
    name: 'Évaluations',
    icon: FileText,
    path: '/evaluations'
  }, {
    name: 'Sondages',
    icon: BarChart2,
    path: '/sondages'
  }, {
    name: 'Compétences',
    icon: Star,
    path: '/competences'
  }, {
    name: 'Onboarding',
    icon: Clipboard,
    path: '/onboarding'
  }, {
    name: 'Documents',
    icon: Folder,
    path: '/documents'
  }, {
    name: 'Performance',
    icon: Target,
    path: '/performance'
  }, {
    name: 'RASCI',
    icon: Grid3x3,
    path: '/rasci'
  }];
  const managerLinks = [{
    name: 'Tableau de bord',
    icon: Home,
    path: '/manager'
  }, {
    name: '2x4',
    icon: Newspaper,
    path: '/manager/2x4'
  }, {
    name: 'Calendrier',
    icon: CalendarDays,
    path: '/manager/calendrier'
  }, {
    name: 'Mon équipe',
    icon: Users,
    path: '/manager/equipe'
  }, {
    name: 'Approbations',
    icon: CheckSquare,
    path: '/manager/approbations'
  }, {
    name: 'Évaluations',
    icon: FileText,
    path: '/manager/evaluations'
  }, {
    name: 'Compétences',
    icon: Star,
    path: '/manager/competences'
  }, {
    name: 'Onboarding',
    icon: Clipboard,
    path: '/manager/onboarding'
  }, {
    name: 'Performance',
    icon: Target,
    path: '/manager/performance'
  }, {
    name: 'Rapports',
    icon: Award,
    path: '/manager/rapports'
  }, {
    name: 'RASCI',
    icon: Grid3x3,
    path: '/manager/rasci'
  }];
  const links = userRole === 'employee' ? employeeLinks : managerLinks;
  return <div className="hidden md:flex md:flex-shrink-0" data-id="element-718">
      <div className="flex flex-col w-64" data-id="element-719">
        <div className="flex flex-col h-0 flex-1" style={{
        backgroundColor: '#608E42'
      }} data-id="element-720">
          <div className="flex-1 flex flex-col overflow-y-auto" data-id="element-721">
            <div className="flex flex-col flex-shrink-0" data-id="element-722">
              <div className="w-full bg-white px-4 py-4" data-id="element-723">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9WWUuraEkLQnRWH8Naihx7/image.png" alt="Construction Gauthier" className="w-full h-auto" data-id="element-724" />
              </div>
              <div className="px-4 py-4 text-center border-b border-green-700" data-id="element-725">
                <h1 className="text-white font-bold text-xl tracking-wide" data-id="element-726">
                  Ma place RH
                </h1>
              </div>
            </div>
            <nav className="flex-1 px-2 py-4 space-y-1" data-id="element-727">
              {links.map(link => {
              const Icon = link.icon;
              return <Link key={link.path} to={link.path} className={`${isActive(link.path) ? 'bg-green-800 text-white' : 'text-green-100 hover:bg-green-700 hover:text-white'} group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors`} data-id="element-728">
                    <Icon className="mr-3 h-5 w-5" data-id="element-729" />
                    {link.name}
                  </Link>;
            })}
            </nav>
          </div>
          <div className="flex-shrink-0 flex bg-green-900 p-4" data-id="element-730">
            <div className="flex items-center" data-id="element-731">
              <div className="ml-3" data-id="element-732">
                <p className="text-sm font-medium text-white" data-id="element-733">
                  {userRole === 'employee' ? 'Mode Employé' : 'Mode Gestionnaire'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}